var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 168,
    viewBox: "0 0 167 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.32 113.152C143.25 150.729 100.443 171.78 63.3208 166.101C57.2799 165.177 40.7195 162.425 26.0577 149.438C-2.1675 124.442 -8.20356 74.947 14.565 40.0654C31.1385 14.6788 60.842 0.286905 89.0685 1.0062C95.1484 1.16157 118.449 2.11747 138.927 18.8855C141.935 21.3482 148.569 27.201 154.547 36.4855C168.586 58.288 169.793 88.6635 159.32 113.152Z",
    fill: "url(#paint0_linear_2434_12894)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2434_12894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 21,
    width: 53,
    height: 53
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.453 73.917C150.971 73.917 162.739 62.1483 162.739 47.6309C162.739 33.1134 150.971 21.3447 136.453 21.3447C121.936 21.3447 110.167 33.1134 110.167 47.6309C110.167 62.1483 121.936 73.917 136.453 73.917Z",
    fill: "#91B3FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2434_12894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.453 73.917C150.971 73.917 162.739 62.1483 162.739 47.6309C162.739 33.1134 150.971 21.3447 136.453 21.3447C121.936 21.3447 110.167 33.1134 110.167 47.6309C110.167 62.1483 121.936 73.917 136.453 73.917Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.558 50.7281C123.558 50.7281 138.72 47.8225 150.857 50.6398L150.46 63.0991C150.46 63.0991 147.814 80.4495 145.657 88.1483C145.657 88.1483 136.485 90.0536 131.995 87.7925C131.995 87.7925 127.678 66.2527 125.568 63.1098C125.568 63.1086 123.29 54.7516 123.558 50.7281Z",
    fill: "url(#paint1_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.786 39.4238L132.603 49.7419C132.603 49.7419 136.908 51.5523 139.812 49.4229L138.937 42.1937L133.786 39.4238Z",
    fill: "url(#paint2_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.106 32.5248C140.157 32.6102 141.241 37.7579 141.909 40.9453C141.974 41.2558 141.973 41.5765 141.905 41.8865C141.837 42.1964 141.705 42.4885 141.516 42.7437C141.328 42.9988 141.087 43.2112 140.811 43.3669C140.534 43.5225 140.228 43.618 139.912 43.647L138.685 43.7596C137.598 43.8598 136.513 43.5505 135.642 42.8924C134.771 42.2343 134.177 41.2748 133.976 40.2017L132.896 34.4218C132.896 34.4218 138.877 30.4576 140.106 32.5248Z",
    fill: "url(#paint3_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.573 34.4798C131.083 33.9087 130.641 32.9748 131.611 31.9459C132.595 30.904 133.755 31.1157 134.498 31.4324C134.826 31.5712 135.222 31.4917 135.446 31.2124C135.502 31.1415 135.575 31.0863 135.658 31.0523C135.741 31.0183 135.832 31.0066 135.921 31.0185C136.02 31.0286 136.121 31.0189 136.217 30.9899C136.312 30.9609 136.401 30.9132 136.478 30.8495C136.556 30.7859 136.619 30.7076 136.666 30.6191C136.713 30.5306 136.741 30.4338 136.75 30.3342C136.813 29.6036 137.173 28.7331 138.452 28.4431C140.798 27.9094 142.053 30.234 142.065 31.8961C142.077 33.5583 139.501 33.9917 138.024 33.764C136.939 33.5968 136.037 34.5747 135.635 35.106C135.563 35.2009 135.514 35.3109 135.491 35.4278C135.468 35.5446 135.472 35.6652 135.503 35.7802L135.928 37.3724C135.686 37.8794 135.449 38.3971 135.098 38.8347C134.847 39.1496 134.565 39.3281 134.264 39.4093C133.797 38.6046 132.561 38.5056 131.989 38.5062C131.881 38.5064 131.774 38.4843 131.675 38.4413C131.575 38.3982 131.486 38.3351 131.413 38.2559C130.965 37.775 130.254 36.6922 131.511 35.5655C131.661 35.4282 131.751 35.238 131.763 35.0352C131.774 34.8324 131.706 34.6331 131.573 34.4798Z",
    fill: "url(#paint4_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.748 41.1118C134.748 41.1118 134.603 38.2168 133.421 37.9832C132.24 37.7496 131.003 38.6355 132.062 40.3398C133.38 42.4567 134.748 41.1118 134.748 41.1118Z",
    fill: "url(#paint5_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.558 50.7285C123.558 50.7285 100.733 77.1688 128.928 86.0851L128.862 84.0796C128.862 84.0796 118.147 75.5998 125.775 63.3029C125.775 63.3047 124.399 51.9056 123.558 50.7285Z",
    fill: "url(#paint6_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.857 50.6396C150.857 50.6396 176.333 74.7003 148.781 85.4364L148.716 83.4309C148.716 83.4309 158.856 74.2674 150.441 62.4983C150.44 62.4971 149.318 52.6973 150.857 50.6396Z",
    fill: "url(#paint7_linear_2434_12894)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2434_12894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 7,
    width: 53,
    height: 53
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4771 59.6631C92.9945 59.6631 104.763 47.8944 104.763 33.377C104.763 18.8595 92.9945 7.09082 78.4771 7.09082C63.9596 7.09082 52.1909 18.8595 52.1909 33.377C52.1909 47.8944 63.9596 59.6631 78.4771 59.6631Z",
    fill: "#91B3FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2434_12894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4771 59.5723C92.9945 59.5723 104.763 47.8036 104.763 33.2861C104.763 18.7687 92.9945 7 78.4771 7C63.9596 7 52.1909 18.7687 52.1909 33.2861C52.1909 47.8036 63.9596 59.5723 78.4771 59.5723Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6847 28.5637C48.4862 23.9784 53.2608 21.4639 57.7307 21.7819C59.0789 21.8643 60.4193 21.5252 61.5661 20.8116C63.7315 19.4804 66.4768 19.3561 68.7162 20.7228L68.7339 20.7332C69.229 21.0512 69.7959 21.2399 70.3829 21.2817C70.9698 21.3236 71.5578 21.2174 72.093 20.9728C75.285 19.4404 82.2694 20.3279 85.2735 22.1561C90.27 25.2046 90.8942 31.4864 87.4596 37.1086C84.0251 42.7307 74.5351 44.6521 69.5371 41.6037C68.8533 41.1871 68.2251 40.6857 67.6675 40.1112C67.5013 39.9344 67.2963 39.7984 67.0688 39.7141C66.8412 39.6297 66.5972 39.5992 66.3558 39.625C66.1145 39.6508 65.8825 39.7322 65.6779 39.8627C65.4733 39.9933 65.3017 40.1695 65.1766 40.3775C65.1663 40.3952 65.1544 40.413 65.1441 40.4322C61.3442 46.6608 53.9027 49.0525 48.5335 45.7733C43.1643 42.4941 41.8893 34.7938 45.6847 28.5637Z",
    fill: "url(#paint8_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8685 74.3413C96.8685 74.3413 94.9506 55.3648 84.8363 55.0864C84.8363 55.0864 85.3379 48.9205 87.1259 48.6282C87.1259 48.6282 101.6 51.8192 97.9366 72.4013L96.8685 74.3413Z",
    fill: "url(#paint9_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0982 74.9962C65.0982 74.9962 64.1485 56.3564 74.0703 54.4247C74.0703 54.4247 72.6525 48.5536 70.8477 48.5652C70.8477 48.5652 57.069 54.0254 63.7573 73.2979L65.0982 74.9962Z",
    fill: "url(#paint10_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9453 39.8463L76.1406 47.8084C76.1406 47.8084 80.4686 49.2772 83.3203 47.6191L82.5497 39.6318L76.9453 39.8463Z",
    fill: "url(#paint11_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6072 48.5655C70.6072 48.5655 78.0664 45.801 87.379 48.6631C87.379 48.6631 88.4144 55.7126 87.8849 59.0673L71.8393 59.6486L70.6072 48.5655Z",
    fill: "url(#paint12_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.938 58.6895L87.6658 61.272C87.6658 61.272 82.7315 61.2912 71.8288 60.9244L71.7726 59.0563C71.7726 59.0563 83.8497 59.2959 87.938 58.6895Z",
    fill: "url(#paint13_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9022 32.1265C89.1403 36.9144 88.7794 42.4168 83.1468 43.6504C79.2494 44.5053 75.1596 40.5339 73.9156 35.7459C72.6717 30.958 74.8031 27.3149 78.6592 26.3135C82.5152 25.3122 86.6627 27.346 87.9022 32.1265Z",
    fill: "url(#paint14_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4779 33.604C87.4779 33.604 87.6628 30.7094 89.105 31.6013C90.5471 32.4932 88.5473 35.9633 87.6554 36.1674C86.7635 36.3715 87.4779 33.604 87.4779 33.604Z",
    fill: "url(#paint15_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1275 36.943C75.1275 36.943 74.6956 34.7347 73.1307 35.7597C71.5658 36.7848 74.5506 40.3879 76.3848 39.5862L75.1275 36.943Z",
    fill: "url(#paint16_linear_2434_12894)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2434_12894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 85,
    width: 54,
    height: 53
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.085 137.698C154.603 137.698 166.372 125.93 166.372 111.412C166.372 96.8947 154.603 85.126 140.085 85.126C125.568 85.126 113.799 96.8947 113.799 111.412C113.799 125.93 125.568 137.698 140.085 137.698Z",
    fill: "#91B3FA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2434_12894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.786 137.572C154.304 137.572 166.072 125.804 166.072 111.286C166.072 96.7687 154.304 85 139.786 85C125.269 85 113.5 96.7687 113.5 111.286C113.5 125.804 125.269 137.572 139.786 137.572Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.667 98.2789C135.618 98.372 132.524 100.651 132.524 100.651C132.524 100.651 133.208 105.541 135.983 107.47C139.035 109.593 143.345 105.722 143.345 105.722C143.345 105.722 146.775 106.537 148.598 99.3973C149.017 97.7589 146.602 97.6183 143.686 97.9225C139.926 98.3121 135.667 98.2789 135.667 98.2789Z",
    fill: "url(#paint17_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.882 114.962C131.091 114.128 132.433 113.504 133.851 113.116C134.384 112.971 137.262 113.807 139.042 113.768C141.484 113.712 143.971 112.601 145.984 113.102C147.984 113.6 149.621 114.252 150.566 114.923C153.395 116.936 155.056 120.688 156.068 124.404C154.152 126.371 151.74 127.246 151.74 127.246L151.294 145.31L140.613 150.775L128.421 144.654L128.857 127.001C128.857 127.001 124.985 125.198 124.701 124.542C124.417 123.887 126.466 117.311 129.882 114.962Z",
    fill: "url(#paint18_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.882 124.462C124.882 124.462 119.694 138.846 131.523 144.756C133.98 144.43 133.035 140.351 133.035 140.351C133.035 140.351 127.895 139.213 129.438 127.215C128.018 126.043 124.882 124.462 124.882 124.462Z",
    fill: "url(#paint19_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.818 124.462C155.818 124.462 159.388 139.476 149.177 144.756C146.721 144.43 147.665 140.351 147.665 140.351C147.665 140.351 151.809 138.311 151.262 127.215C152.682 126.043 155.818 124.462 155.818 124.462Z",
    fill: "url(#paint20_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.851 113.115C133.851 113.115 134.93 117.793 140.171 117.696C145.508 117.598 145.982 113.1 145.982 113.1L142.496 112.354L142.204 108.469L136.96 108.857L136.862 112.548L133.851 113.115Z",
    fill: "url(#paint21_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7 97.46C137.7 97.46 131.69 109.102 138.819 111.929C143.849 113.921 147.003 104.198 146.061 101.564C144.607 97.492 143.649 97.9753 143.649 97.9753L137.7 97.46Z",
    fill: "url(#paint22_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.505 96.4023C150.474 97.2183 147.937 103.658 143.466 102.135C138.995 100.613 137.24 100.635 136.542 101.863C135.845 103.091 135.696 107.449 134.184 105.294C132.528 102.932 131.604 98.1908 133.635 96.6621C135.451 95.2982 135.875 93.1782 138.053 93.2518C140.943 93.349 143.179 92.0658 144.484 92.992C145.983 94.0535 145.32 95.7998 147.505 96.4023Z",
    fill: "url(#paint23_linear_2434_12894)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.268 102.863C136.268 102.863 134.986 101.484 134.781 103.146C134.575 104.808 135.234 106.95 136.006 105.776C136.777 104.603 136.268 102.863 136.268 102.863Z",
    fill: "url(#paint24_linear_2434_12894)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.696 59.4082C136.696 59.4082 125.226 61.9379 118.248 65.1602C116.867 65.7997 115.76 66.9124 115.128 68.2971C113.041 72.8679 106.799 84.3299 94.6919 89.7996C96.4353 92.1123 99.2431 96.9274 100.466 105.018C107.737 99.6059 114.015 90.5676 117.029 75.7439C117.029 75.7439 119.324 76.9892 122.188 75.6016C123.7 74.8669 125.449 73.8226 126.758 73.0055C128.067 72.1884 129.037 70.9194 129.415 69.4369C129.914 67.48 129.62 65.7603 129.62 63.9114L135.516 62.085C135.516 62.085 137.288 61.4149 136.696 59.4082Z",
    fill: "url(#paint25_linear_2434_12894)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.495 151.559C16.9095 148.036 18.6878 144.67 20.8011 141.516C17.2603 135.544 16.2119 127.386 22.4953 116.764C27.0767 129.135 29.2263 147.184 29.6752 155.176C29.7594 156.674 29.2945 158.998 28.8788 160.721C28.8072 161.015 28.7961 161.322 28.8461 161.621C28.8961 161.92 29.0062 162.206 29.1698 162.461C29.3333 162.716 29.5469 162.936 29.7977 163.106C30.0484 163.277 30.3312 163.395 30.6287 163.453C40.0609 165.28 49.1568 166.128 57.4723 164.705C58.0715 164.601 58.6266 164.323 59.0675 163.904C59.5085 163.486 59.8155 162.946 59.9498 162.353C65.3858 138.354 65.3526 121.835 63.9276 111.264C69.561 112.522 86.7756 115.207 100.466 105.018C99.2432 96.9268 96.4336 92.1134 94.692 89.799C87.1711 93.1968 77.3879 94.2832 64.9298 89.9662C63.7816 89.5701 62.5844 89.3338 61.3718 89.2641C54.7398 88.8751 32.8845 88.1659 14.8 94.1403C12.9241 94.7586 11.1997 95.7654 9.73908 97.095C8.27848 98.4247 7.11455 100.047 6.32318 101.857C1.42981 113.083 -6.49256 138.651 15.495 151.559Z",
    fill: "url(#paint26_linear_2434_12894)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9521 111.945C63.8304 111.945 63.713 111.901 63.6216 111.821C63.5302 111.74 63.4711 111.63 63.4551 111.509C62.0414 100.831 59.1631 96.1706 59.134 96.125C59.0669 96.0126 59.0463 95.8785 59.0766 95.7512C59.1069 95.6239 59.1857 95.5135 59.2962 95.4434C59.4067 95.3733 59.5402 95.3491 59.6683 95.3759C59.7964 95.4028 59.9089 95.4786 59.982 95.5871C60.1053 95.7804 63.0062 100.447 64.4502 111.377C64.4589 111.443 64.4546 111.509 64.4376 111.573C64.4205 111.636 64.3912 111.696 64.3511 111.748C64.311 111.801 64.261 111.845 64.2039 111.878C64.1468 111.911 64.0838 111.932 64.0185 111.941C63.9965 111.944 63.9743 111.945 63.9521 111.945Z",
    fill: "url(#paint27_linear_2434_12894)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4055 74.4893C33.4055 74.4893 32.1531 87.7296 31.0507 91.6457C30.9693 91.9343 30.9872 92.2419 31.1015 92.5191C31.2158 92.7963 31.4199 93.0271 31.6811 93.1744C33.5525 94.2418 38.0403 95.9876 44.1795 92.9793C44.6636 92.7393 45.0675 92.3636 45.3419 91.8982C45.6164 91.4327 45.7497 90.8975 45.7255 90.3577L45.1847 77.5639L33.4055 74.4893Z",
    fill: "url(#paint28_linear_2434_12894)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4547 57.5527C45.4547 57.5527 49.4597 66.753 49.729 71.5817C49.9982 76.4105 51.0383 79.5444 45.4547 80.5169C39.8711 81.4894 35.1674 78.7071 32.6211 73.8968C32.6211 73.8968 28.6285 66.4844 29.5239 63.4494C30.4194 60.4145 45.4547 57.5527 45.4547 57.5527Z",
    fill: "url(#paint29_linear_2434_12894)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5273 70.4383L34.8451 70.2983C34.9411 70.2564 35.0274 70.1952 35.0989 70.1186C35.1703 70.0419 35.2252 69.9515 35.2604 69.8528C35.2955 69.7541 35.31 69.6493 35.303 69.5448C35.2961 69.4403 35.2678 69.3383 35.2199 69.2452C34.4324 67.7241 32.8977 64.2379 34.8807 63.4249C37.4359 62.3765 47.5583 60.3123 49.7423 56.7206C51.8414 53.2688 49.9795 48.8124 47.1865 47.5452C47.0975 47.5028 46.9956 47.4962 46.9019 47.5268C46.8082 47.5573 46.7298 47.6227 46.683 47.7095L46.45 48.1501C46.4148 48.2171 46.3603 48.272 46.2937 48.3078C46.227 48.3436 46.1511 48.3586 46.0758 48.3508C46.0005 48.3431 45.9293 48.313 45.8713 48.2645C45.8132 48.2159 45.7711 48.1511 45.7502 48.0783C45.7305 48.0079 45.6907 47.9447 45.6357 47.8965C45.5808 47.8483 45.5129 47.8171 45.4406 47.8068C45.3682 47.7964 45.2943 47.8073 45.228 47.8381C45.1617 47.869 45.1058 47.9184 45.0671 47.9805C44.3958 49.055 42.5831 50.7972 37.7365 51.6914C30.8483 52.9628 26.2918 55.7504 26.1809 60.5104C26.1798 60.5783 26.1605 60.6447 26.125 60.7027C26.0896 60.7606 26.0392 60.808 25.9793 60.84C25.9193 60.8719 25.8519 60.8872 25.784 60.8843C25.7161 60.8814 25.6503 60.8604 25.5933 60.8235C25.0851 60.5134 24.2709 60.3681 23.1833 61.2825C21.2917 62.8735 22.0655 66.9995 26.2123 70.3938C26.2591 70.4301 26.2967 70.477 26.322 70.5306C26.3472 70.5842 26.3595 70.643 26.3578 70.7022C26.356 70.7614 26.3404 70.8194 26.312 70.8714C26.2836 70.9235 26.2434 70.9681 26.1945 71.0016C25.4426 71.4908 24.3219 72.6555 27.2264 74.2073C30.2299 75.8131 32.4726 75.6815 33.3342 75.5392C33.3849 75.5307 33.4335 75.5119 33.4767 75.484C33.52 75.4561 33.5571 75.4197 33.5858 75.3769C33.6145 75.3342 33.6342 75.286 33.6437 75.2354C33.6531 75.1848 33.6521 75.1328 33.6407 75.0826L32.7186 70.899C32.7065 70.8436 32.7069 70.7862 32.7199 70.7309C32.7329 70.6757 32.7581 70.6241 32.7936 70.5799C32.8292 70.5357 32.8742 70.5 32.9254 70.4755C32.9765 70.451 33.0325 70.4383 33.0893 70.4383H34.5273Z",
    fill: "url(#paint30_linear_2434_12894)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7007 71.3215C34.7007 71.3215 33.1726 65.4443 30.5379 67.0923C27.9033 68.7402 31.9054 73.6745 34.0235 73.8968L34.7007 71.3215Z",
    fill: "url(#paint31_linear_2434_12894)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.088 74.3763C119.993 74.3764 119.9 74.3495 119.819 74.2988C119.739 74.2481 119.675 74.1756 119.634 74.0899C119.593 74.0041 119.578 73.9085 119.589 73.8143C119.601 73.72 119.639 73.6309 119.699 73.5574C120.132 73.0237 123.982 68.3171 125.465 67.4798C126.005 67.175 126.326 66.8601 126.394 66.5695C126.425 66.4084 126.402 66.2414 126.327 66.0952L121.807 67.0036L119.244 69.2024C119.143 69.2852 119.013 69.325 118.883 69.3133C118.752 69.3016 118.632 69.2394 118.546 69.1399C118.461 69.0404 118.418 68.9115 118.427 68.7808C118.435 68.6501 118.495 68.528 118.592 68.4404L121.254 66.1556C121.319 66.1 121.398 66.0618 121.482 66.0447L126.489 65.0414C126.586 65.0215 126.687 65.031 126.779 65.0687C126.871 65.1064 126.949 65.1706 127.004 65.2531C127.371 65.7975 127.493 66.3039 127.376 66.7996C127.237 67.3861 126.775 67.8949 125.963 68.3539C124.847 68.9842 121.628 72.7811 120.481 74.1913C120.434 74.2498 120.374 74.2969 120.306 74.329C120.238 74.361 120.163 74.3772 120.088 74.3763Z",
    fill: "url(#paint32_linear_2434_12894)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5064 157.921L52.2096 158.14L46.014 152.307C44.4723 150.858 42.1234 150.623 40.3456 151.774C39.1549 152.537 38.0926 153.483 37.198 154.579C37.198 154.579 26.1577 150.545 20.8012 141.516C18.688 144.669 16.9097 148.035 15.4951 151.557C20.2942 154.375 26.5135 156.59 34.5064 157.921Z",
    fill: "url(#paint33_linear_2434_12894)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4164 160.204C36.4502 160.204 36.4846 160.204 36.5195 160.204L81.4571 160.155C81.7184 160.155 81.9771 160.103 82.2185 160.003C82.4598 159.902 82.679 159.756 82.8637 159.571C83.0483 159.386 83.1946 159.166 83.2944 158.925C83.3941 158.683 83.4453 158.424 83.4451 158.163C83.4448 157.901 83.393 157.643 83.2928 157.401C83.1925 157.16 83.0457 156.941 82.8607 156.756C82.6757 156.572 82.4562 156.425 82.2146 156.326C81.9731 156.226 81.7142 156.175 81.4529 156.175L36.5148 156.223C35.9873 156.21 35.4762 156.407 35.094 156.771C34.7118 157.135 34.4897 157.636 34.4767 158.163C34.4636 158.691 34.6607 159.202 35.0244 159.584C35.3882 159.966 35.8889 160.188 36.4164 160.201V160.204Z",
    fill: "url(#paint34_linear_2434_12894)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.852 119.834H84.4276C83.0799 119.831 81.7589 120.209 80.6173 120.926C79.4757 121.642 78.5601 122.666 77.9764 123.881L60.6753 160.18H107.184C108.05 160.182 108.897 159.925 109.616 159.442C110.334 158.958 110.892 158.27 111.216 157.467L124.632 123.878C125.407 121.937 123.961 119.834 121.852 119.834Z",
    fill: "url(#paint35_linear_2434_12894)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.087 140.253C101.908 137.763 101.321 135.332 99.7758 134.823C98.2308 134.314 96.3132 135.92 95.4926 138.41C94.672 140.899 95.2593 143.331 96.8042 143.84C98.3492 144.349 100.267 142.743 101.087 140.253Z",
    fill: "#7D97F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2434_12894",
    x1: 180.169,
    y1: 169.606,
    x2: 56.1942,
    y2: 61.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2434_12894",
    x1: 169.872,
    y1: 24.6992,
    x2: 118.171,
    y2: 90.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2434_12894",
    x1: 139.108,
    y1: 61.3681,
    x2: 133.887,
    y2: 37.2719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2434_12894",
    x1: 110008,
    y1: -91479.1,
    x2: 111521,
    y2: -92804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2434_12894",
    x1: 130.593,
    y1: 37.2079,
    x2: 141.79,
    y2: 30.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2434_12894",
    x1: 37959.5,
    y1: -30508.6,
    x2: 38462.6,
    y2: -30969.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2434_12894",
    x1: 45214.9,
    y1: 31606.8,
    x2: 20049.4,
    y2: 43508.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2434_12894",
    x1: 44692,
    y1: 38731.1,
    x2: 21107.4,
    y2: 49083.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2434_12894",
    x1: -44081.2,
    y1: 33357.1,
    x2: -50858.4,
    y2: 24880.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2434_12894",
    x1: 37406.7,
    y1: -57196.7,
    x2: 38153.5,
    y2: -54348.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2434_12894",
    x1: -37445.7,
    y1: 10048.9,
    x2: -38846.5,
    y2: 8912.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2434_12894",
    x1: -8492.64,
    y1: 8407,
    x2: -8119.28,
    y2: 10118.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2434_12894",
    x1: -3211.36,
    y1: 13141.6,
    x2: -4435.82,
    y2: 16085.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2434_12894",
    x1: -18753.4,
    y1: 3122.08,
    x2: -18770.6,
    y2: 2774.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2434_12894",
    x1: -14038.9,
    y1: 26824.2,
    x2: -12934.2,
    y2: 24982.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2434_12894",
    x1: -992.96,
    y1: 5957.62,
    x2: -697.3,
    y2: 5649.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2434_12894",
    x1: -2612.47,
    y1: 5438.74,
    x2: -2372.49,
    y2: 4993.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2434_12894",
    x1: 48090.7,
    y1: 18075.9,
    x2: 46275,
    y2: 21719.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2434_12894",
    x1: 90252.6,
    y1: 85886.8,
    x2: 81486.4,
    y2: 119777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2434_12894",
    x1: 23862.6,
    y1: 50295.2,
    x2: 33621.5,
    y2: 61289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2434_12894",
    x1: 64624.9,
    y1: 50259.1,
    x2: 54815.4,
    y2: 60692.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2434_12894",
    x1: 34206.5,
    y1: 23552.4,
    x2: 34174.6,
    y2: 19895.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2434_12894",
    x1: 28263.1,
    y1: 27249.1,
    x2: 29357.5,
    y2: 22286.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2434_12894",
    x1: 48345.7,
    y1: 20343.5,
    x2: 45420.6,
    y2: 25264.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2434_12894",
    x1: 5655.86,
    y1: 10513.2,
    x2: 5571.41,
    y2: 8473.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2434_12894",
    x1: 102173,
    y1: 76559.2,
    x2: 73463.5,
    y2: 111055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2434_12894",
    x1: 105085,
    y1: 199131,
    x2: -39783,
    y2: 423047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2434_12894",
    x1: 13748.3,
    y1: 13870.5,
    x2: 346.144,
    y2: 19493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2434_12894",
    x1: 15413.7,
    y1: 44389.6,
    x2: 17226.9,
    y2: 37437.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2434_12894",
    x1: 25303.9,
    y1: 35848.2,
    x2: 16687.7,
    y2: 41709.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2434_12894",
    x1: 27202.5,
    y1: 36918.3,
    x2: 37281.2,
    y2: 50046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2434_12894",
    x1: 5965.05,
    y1: 10590,
    x2: 3585.45,
    y2: 11880.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2434_12894",
    x1: 23477.7,
    y1: 8976.3,
    x2: 22656.7,
    y2: 15329.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2434_12894",
    x1: 23363.3,
    y1: 47561.1,
    x2: 42500.4,
    y2: 66530.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2434_12894",
    x1: 168502,
    y1: 20003.7,
    x2: 170717,
    y2: 28987.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2434_12894",
    x1: 268165,
    y1: 102983,
    x2: 283457,
    y2: 128689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.871e26e2d6bdcee7150934e84b15d233.svg";
export { ForwardRef as ReactComponent };